import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.8/js/sparta-ui-layers-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import Module from "utilities/global/sparta-module-utility/6.3.0/js/sparta-module-utility";
import spartaMessageUtility from "utilities/global/sparta-messaging-utility/2.1.7/js/sparta-messaging-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.8/js/sparta-validation-framework";
import "utilities/vendor/jsencrypt/2.3.1/js/jsencrypt";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import textInput from "utilities/helpers/helpers-text-inputs/4.1.2/js/helpers-text-inputs";
import fingerprintUtility from "utilities/login/fingerprint-utility/2.0.0/js/fingerprint-utility";
import AhSafepassCommonsUtility from "utilities/login/ah-safepass-commons-utility/2.0.0/js/ah-safepass-commons-utility";
import spartaTemplates from "modules/login/ah-safepass-module/4.1.0/js/templates";
import "css!modules/login/ah-safepass-module/4.1.0/css/ah-safepass-module.scss.css";









export default class ahSafepassModuleJS extends Module {
  constructor(options) {
    super(options);
    this.ahSPCommons = new AhSafepassCommonsUtility(
        {
          '$' : $,
          '_' : _,
          'cawCommons' : ahCawCommons,
          'cawEventsMaster' : cawEventsMasterUtility,
          'spartaUILayersUtility' : spartaUILayersUtility,
          'spartaMessageUtil' : new spartaMessageUtility(),
          'spartaValidationFramework' : spartaValidationFramework,
          'constructorParams' : options,
          'hb' : Handlebars,
          'jsEncrypt' : window.JSEncryptExports,
          'context': this,
          'ahCawTransportUtility':new ahCawTransportUtility()
        }
      );
      if(options.errorCode){
        this.errorCodeJCR = options.errorCode;
      }
  }

  init(args = {}) {
     const self = this;


     this.ahSPCommons
      	.defineVars()     
     	.compileAllTemplates()
     	.subscribeEvents()
     	.bindEventHandlers()
     	.bindThisContext();
  }
}
